import $ from 'jquery';

const FADE_TIME = 300;

class Expandable {
    constructor() {
        $('.jsExpandableImage').on('click', $.proxy(this.expand, this));
    }

    expand(e) {
        e.preventDefault();
        let $el = $(e.currentTarget);

        let div = $('<div>');
        div.addClass('expandable-overtake');
        div.hide();

        let str = `<div class="expandable-overtake--content"><div class="image-container"><img src="${$el.attr('href')}" /></div><div class="overtake-caption">${$el.data('caption')}</div></div>`;
        div.html(str);

        $('body').append(div);

        div.fadeIn(FADE_TIME);
        div.on('click', this.destroyOvertake);
    }

    destroyOvertake() {

        let overtake = $('body').find('.expandable-overtake');

        overtake.fadeOut(FADE_TIME, () => {
            overtake.remove();
        });

    }
}

export default Expandable;


// WEBPACK FOOTER //
// ./src/js/components/expandable.js